export default (callSign: string) => {
  const snippet =
    `var myCustomTracker = function (player) {
      this.isPlaying = function () {
        return player.paused !== true;
      };

      this.onPlay = function (callback) {
        if (this.isPlaying()) {
          callback();
        }

        player.onplay = callback;
      }

      this.onStopped = function (callback) {
        if (!this.isPlaying()) {
          callback();
        }

        player.onpause = callback;
      }
    };

    ra("${callSign}", {
      tracker: new myCustomTracker(document.getElementById("player"))
    });`;

  return snippet;
};



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/content/radioAnalytics/snippets/customTrackerSnippet.js